import { configureStore } from '@reduxjs/toolkit';
import createRootReducer from './rootReducer';

const middlewares = [];

const store = configureStore({
    reducer: createRootReducer(),
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false,
        }).concat(middlewares),
    devTools: process.env.NODE_ENV === 'development',
});

store.asyncReducers = {};

export const injectReducer = (key, asyncReducer) => {
    if (store.asyncReducers[key]) return;

    store.asyncReducers[key] = asyncReducer;
    store.replaceReducer(createRootReducer(store.asyncReducers));
};

export default store;
